// Create a single global tooltip if it doesn't exist yet
if (!window.globalTooltip) {
  window.globalTooltip = document.createElement('div');
  window.globalTooltip.className = 'madara-tooltip';
  document.body.appendChild(window.globalTooltip);
  
  // Global active trigger tracking
  window.activeTooltipTrigger = null;

  // Global click handler
  document.addEventListener('click', () => {
    window.globalTooltip.style.display = 'none';
    window.activeTooltipTrigger = null;
  });

  // Global scroll handler
  document.addEventListener('scroll', () => {
    window.globalTooltip.style.display = 'none';
    window.activeTooltipTrigger = null;
  }, true);
}

// Initialize all tooltip triggers
function initializeTooltipTriggers() {
  document.querySelectorAll('.madara-tooltip-trigger').forEach(trigger => {
    if (!trigger.dataset.initialized) {
      trigger.dataset.initialized = 'true';
      
      trigger.addEventListener('click', (e) => {
        e.stopPropagation();
        
        if (window.activeTooltipTrigger === trigger) {
          // Close if clicking the active trigger
          window.globalTooltip.style.display = 'none';
          window.activeTooltipTrigger = null;
        } else {
          // Show tooltip for new trigger
          window.globalTooltip.innerHTML = decodeHTMLEntities(trigger);
          window.globalTooltip.style.display = 'block';
          positionTooltip(trigger, window.globalTooltip);
          window.activeTooltipTrigger = trigger;
        }
      });
    }
  });
}

function positionTooltip(trigger, tooltip) {
  const triggerRect = trigger.getBoundingClientRect();
  const tooltipRect = tooltip.getBoundingClientRect();
  
  // Calculate initial position centered on trigger
  const triggerCenter = triggerRect.left + (triggerRect.width / 2);
  let left = triggerCenter - (tooltipRect.width / 2);
  let top = triggerRect.top - tooltipRect.height - 12;
  let position = 'top';

  // Adjust horizontal position if off-screen
  const minLeft = 10;
  const maxLeft = window.innerWidth - tooltipRect.width - 10;
  left = Math.min(Math.max(left, minLeft), maxLeft);

  // Calculate arrow position relative to tooltip
  const arrowLeft = ((triggerCenter - left) / tooltipRect.width) * 100;
  const arrowLeftPosition = Math.min(Math.max(arrowLeft, 10), 90);
  
  tooltip.style.setProperty('--madara-tooltip-arrow-left', `${arrowLeftPosition}%`);

  if (top < 0) {
    top = triggerRect.bottom + 12;
    position = 'bottom';
  }

  if (top + tooltipRect.height > window.innerHeight && triggerRect.top > tooltipRect.height) {
    top = triggerRect.top - tooltipRect.height - 12;
    position = 'top';
  }

  tooltip.style.left = `${left}px`;
  tooltip.style.top = `${top}px`;
  tooltip.className = 'madara-tooltip madara-tooltip-arrow-' + position;
}

document.addEventListener('DOMContentLoaded', initializeTooltipTriggers);

function decodeHTMLEntities(trigger) {
  const text = trigger.dataset.description
  const textarea = document.createElement('textarea');
  textarea.innerHTML = text;

  const content = textarea.querySelector('p');

  if (!content) {
    return trigger.textContent;
  }

  return textarea.value;
} 